export const operatingHrs = [
  {
    day: "sunday",
    selected: false,
    times: [],
    errorsArr: [],
  },
  {
    day: "monday",
    selected: false,
    times: [],
    errorsArr: [],
  },
  {
    day: "tuesday",
    selected: false,
    times: [],
    errorsArr: [],
  },
  {
    day: "wednesday",
    selected: false,
    times: [],
    errorsArr: [],
  },
  {
    day: "thursday",
    selected: false,
    times: [],
    errorsArr: [],
  },
  {
    day: "friday",
    selected: false,
    times: [],
    errorsArr: [],
  },
  {
    day: "saturday",
    selected: false,
    times: [],
    errorsArr: [],
  },
]

export const defaultStoreEntryAuthObj = {
  paymentReader: false,
  customerApp: false,
  freeEntry: false,
}
const defaultStoreEntryAuthArrayList = [
  {
    label: "Payment Reader",
    value: "paymentReader",
  },
  {
    label: "Customer App",
    value: "customerApp",
  },
  {
    label: "Free Entry",
    value: "freeEntry",
  },
]

export const getDefaultStoreEntryAuthList = (props) => {
  const { selectedList = {}, edit = null, values = {}, check = {} } =
    props || {}

  // console.log("check", check)

  const { name = "DigitMart" } = check || {}

  let isPlatformAccountCheck =
    localStorage.getItem("platFormAccountFlag") === "true"

  const dataCollect = []

  defaultStoreEntryAuthArrayList.forEach((item) => {
    // console.log(
    //   "isPlatformAccountCheck",
    //   isPlatformAccountCheck,
    //   defaultStoreEntryAuthArrayList
    // )
    if (
      (isPlatformAccountCheck === false && item.value === "customerApp") ||
      (String(name || "")
        .toLowerCase()
        .includes("mart x") &&
        item.value === "customerApp")
    ) {
      return
    }

    let isCheckedV =
      values.storeEntryAuthentication?.includes(item.value) || false

    dataCollect.push({
      label: item.label,
      value: item.value,
      isChecked: isCheckedV,
    })
  })

  return dataCollect
}

export const getRevertStoreEntryAuthArrayList = (list) => {
  const data = []
  if (!Array.isArray(list)) {
    return data
  }
  list.map((item) => {
    const { isChecked = false, value = "" } = item || {}
    if (isChecked) {
      data.push(value)
    }
  })

  return data
}

export const getTransformObjecToArray = (object = {}) => {
  let data = []
  if (!object || typeof object !== "object" || Array.isArray(object)) {
    return data
  }
  let list = Object.keys(object)
  list.map((itm) => {
    if (object[itm] === true) {
      data.push(itm)
    }
  })
  return data
}
export const getTransformArrayToObject = (array = []) => {
  let object = { ...defaultStoreEntryAuthObj }
  if (!Array.isArray(array)) {
    return object
  }
  array.map((itm) => {
    let list = Object.keys(object)
    list.map((itm2) => {
      if (itm === itm2) {
        object[itm] = true
      }
    })
  })

  return object
}

export const getDetailViewMapping = (array = []) => {
  let dataKit = []
  if (!Array.isArray(array)) {
    return ""
  }
  array.map((item) => {
    const [_xData] = defaultStoreEntryAuthArrayList.filter(
      (itm) => itm?.value === item
    )
    dataKit.push(_xData?.label)
    return ""
  })
  return dataKit.join(", ")
}
